import React, { useState, useEffect } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import MaterialTable, {
  MaterialTableProps,
  MTableBody,
  MTableHeader
} from 'material-table';
import { Button, TableBody, TableRow, TableCell, Link } from '@material-ui/core';
import axios from 'axios';

import StudentLayout from '../../../layouts/StudentLayout';
import Course from '../../../models/Course';
import utils from '../../../libs/utils';
import Auth from '../../../libs/auth';

const Courses = (props: RouteComponentProps) => {
  const [courses, setCourses] = useState<Course[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const tableProps: MaterialTableProps<Course> = {
    title: <h3 className="mt-0 mb-1">Courses</h3>,
    data: courses,
    isLoading,
    columns: [
      {
        title: 'ID',
        field: 'id',
        width: '10%',
      },
      {
        title: 'Name',
        field: 'fullname',
        // defaultSort: 'asc',
        // render(rowData) {
        //   return (
        //     <Link href={`#/student/courses/${rowData.id}/assignments`}>
        //       {rowData.name}
        //     </Link>
        //   );
        // }
      }
    ],
    localization: {
      body: {
        emptyDataSourceMessage: 'No Course/s Found.'
      }
    },
    options: {
      headerStyle: {
        fontWeight: 'bold'
      },
      pageSize: 10,
      pageSizeOptions: [5, 10, 20, 50],
      emptyRowsWhenPaging: false,
      search: true,
      sorting: true,
      draggable: false
    },
    components: {
      Header: (props: any) => {

        return <MTableHeader {...props} />;
      },
      Body: (props: any) =>
        !!errorMessage ? (
          <TableBody>
            <TableRow>
              <TableCell colSpan={4} align="center">
                <div className="text-center p-5">
                  <h2 className="m-0">Error Loading Courses</h2>
                  <p>{errorMessage}</p>
                  <Button
                    type="button"
                    onClick={loadCourses}
                    color="primary"
                    className="mt-3"
                    variant="contained"
                  >
                    Try Again
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <MTableBody {...props} />
        )
    },
    onRowClick: (event, rowData) =>
      props.history.push(`/student/courses/${rowData?.id}/assignments`)
  };

  const loadCourses = async () => {
    try {
      setIsLoading(true);
      setErrorMessage('');
      setCourses([]);

      const session = Auth.getSession();

      const moodleCourses = await Course.getMoodleCourses({
        token: session?.accessToken,
      });

      setCourses(moodleCourses);

      const [
        { data: registeredCoursedIds = []},
        //   _courses
      ] = await Promise.all([
        axios.get('/admin/course-instances'),
        //   await Course.getCourses()
      ]);
      
      setCourses(
        registeredCoursedIds
          ? moodleCourses.filter((c) => registeredCoursedIds.includes(c.id+''))
          : []
      );
    } catch (e) {
      setErrorMessage(utils.getRequestErrorMessage(e));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => await(loadCourses()))();
  }, []);

  return (
    <StudentLayout>
      <div className="p-4">
        <MaterialTable {...tableProps} />
      </div>
    </StudentLayout>
  );
};

export default withRouter(Courses);
